/**
 * @type {String[]}
 */
const NoContainer = [
  // "/System/ChatGPT"
];

export default NoContainer;